/*
 * @Description:
 * @Date: 2021-09-22 12:13:07
 */
// import store from './store';
import { route } from './src/router';

const name = 'taskprocess';

export { name, route };
